import { FETCH_CONFIG } from "./constants";
import update from "immutability-helper";

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_CONFIG.SUCCESS:
      state = update(state, { $set: { ...action.data } });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/config/reducers.js